/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2022, Zumper
 * @description useMapDimensions - get map dimensions for STR/LTR and Large Map/Small Map
 */

import { selectToggleValue } from '@zcode-ui/filters'
import { ON_SERVER } from '@zcode/nr/es/shared/env'
import { useSelector } from 'react-redux'

const HEADER_HEIGHT = 134 // includes filter bar
const MOBILE_HEADER_HEIGHT = 174
const VIEWPORT_OFFSET = 2

export const BREAKPOINT_VISIBLE_MAP = 870

export const useMapDimensions = () => {
  const toggleValue = useSelector(selectToggleValue)
  const isFullWidthMap = toggleValue === 'full-map'

  if (ON_SERVER || typeof document === 'undefined') {
    return { mapHeight: 0, mapWidth: 0 }
  }

  const viewport = {
    height: document.documentElement.clientHeight,
    width: document.documentElement.clientWidth,
  }

  if (viewport.width < 768) {
    return {
      mapHeight: viewport.height - MOBILE_HEADER_HEIGHT,
      mapWidth: viewport.width,
    }
  }

  if (viewport.width < 992) {
    return {
      mapHeight: viewport.height - HEADER_HEIGHT,
      mapWidth: isFullWidthMap
        ? viewport.width - VIEWPORT_OFFSET
        : viewport.width / 2 - VIEWPORT_OFFSET,
    }
  }

  let railWidth = isFullWidthMap ? 0 : 1103

  if (viewport.width >= 1280 && viewport.width < 1440) {
    railWidth = isFullWidthMap ? 0 : viewport.width / 2
  } else if (viewport.width < 1280) {
    railWidth = isFullWidthMap ? 0 : 670
  }

  return {
    mapHeight: viewport.height - HEADER_HEIGHT - VIEWPORT_OFFSET,
    mapWidth: viewport.width - railWidth - VIEWPORT_OFFSET,
  }
}
